import { BaseEntity } from "../base-entity";
import { BreezeModelBuilder } from "../breeze-model-builder";
import { EntityExtensions } from "../entity-extensions.decorator";
import { Person } from "../person/person";
import { Organisation } from "./organisation";
import { Team } from "./team";
import { VisionCategory } from "./vision-category";
import { VisionExtensions } from "./vision-extensions";

export enum VisionType {
    Personal = "Personal",
    Integrated = "Integrated",
}

export enum VisionStatus {
    InProgress = "InProgress",
    Completed = "Completed",
}

export class Vision extends BaseEntity<Vision> {
    public visionId!: number;
    public organisationId!: number;
    public teamId!: number;
    public personId?: number;
    public visionCategoryId?: number;
    public type!: VisionType;
    public status!: VisionStatus;
    public statement!: string;
    public lastUpdated?: Date;
    public lastPublished?: Date;

    public organisation!: Organisation;
    public team!: Team;
    public person?: Person; // integrated can be without person? or set to whoever editing
    public visionCategory?: VisionCategory; // without category -> summary

    @EntityExtensions(VisionExtensions)
    public extensions!: VisionExtensions;
}

export const VisionBreezeModel = new BreezeModelBuilder("Vision", Vision)
    .hasSource()
    .withIdField()
    .isOrganisationEntity()
    .build();
